import { useState } from 'react';

// AskLauncher — the single-line "ask" entry carried by other surfaces (the knowledge map, the briefing).
// It is a NAVIGATOR, not a state-mutator: submitting routes to /ask?q=<question>, which prefills + focuses
// the Ask composer (never auto-submits — a 20-45s turn must not fire from a URL), so every answer lands on
// the one Ask surface. Its own draft state; token CSS (.ask-launch). Replaces the former AskEntry.
// Navigation goes through the host's `onNav` (the SPA convention) — NOT useNavigate — so any surface that
// hosts it (the map, the briefing) stays renderable/testable outside a <Router>.
export function AskLauncher({
  onNav,
  placeholder = "Ask your team's knowledge…",
}: {
  onNav: (id: string) => void;
  placeholder?: string;
}) {
  const [draft, setDraft] = useState('');
  const launch = () => {
    const q = draft.trim();
    if (!q) return;
    onNav(`ask?q=${encodeURIComponent(q)}`);
    setDraft('');
  };
  return (
    <div className="ask-launch">
      <span className="ask-launch-ic" aria-hidden="true">◈</span>
      <input
        className="ask-launch-input"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter') launch(); }}
        placeholder={placeholder}
        aria-label="Ask a question"
      />
      <button className="ask-launch-send" onClick={launch} disabled={!draft.trim()} aria-label="Ask">↑</button>
    </div>
  );
}
